import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { assignHighlight, getNovelties, showNovelty, toggleFormNovelty } from '../../../../../redux/actions/novelties'
import { getTags } from '../../../../../redux/actions/tags';
import { IRootState } from "../../../../../redux/types";


export function useNoveltiesTable() {
  const dispatch = useDispatch()

  const [openDeleteNovelty, setOpenDeleteNovelty] = useState(false)
  const [noveltySelected, setNoveltySelected] = useState<number | false>(false)

  const { novelties, reload, showForm, loading } = useSelector((state: IRootState) => state.novelty)
  const { tags } = useSelector((state: IRootState) => state.tag)
  const { globalFamilyId, globalBrandId, globalCountriesId, globalLanguageId } = useSelector((state: IRootState) => state.global)

  useEffect(() => {
    if (tags.length === 0) dispatch(getTags())
  }, [])

  useEffect(() => {
    if (globalLanguageId !== null && globalCountriesId.length > 0) {
      fetchNovelties()
    }
  }, [globalFamilyId, globalBrandId, globalLanguageId, globalCountriesId])

  useEffect(() => {
    if (reload) {
      fetchNovelties()
    }
  }, [reload])

  const fetchNovelties = (filterBy?: any) => {
    dispatch(
      getNovelties({
        family_id: globalFamilyId,
        brand_id: globalBrandId,
        language_id: globalLanguageId,
        countries: globalCountriesId,
        requesttype: 0,
        type: 'novelties',
        ...(filterBy && { filterBy })
      })
    )
  }

  const handleEditNovelties = (id: number) => {
    dispatch(showNovelty({ id, type: 'noveltySelected' }))
    dispatch(toggleFormNovelty({ type: 'noveltySelected', change: false }))
  }

  const handleDeleteNovelties = (id: number) => {
    setOpenDeleteNovelty(!openDeleteNovelty)
    setNoveltySelected(id)
  }

  const handleClickHighlight = (id: number, isHighlight: boolean) => {
    dispatch(assignHighlight({ id, isHighlight }))
  }

  const handleClickSetOptions = (options: any) => {
    fetchNovelties(options)
  }

  const handleCreateNovelty = () => {
    dispatch(toggleFormNovelty({ type: 'noveltySelected', change: true }))
  }

  const createOptionsData = (t: (key: string) => string) => {
    const status = [
      { id: 0, name: 'Activo' },
      { id: 1, name: 'Inactivo' },
      { id: 2, name: 'Borrador' }
    ]
    const visibility = [
      { id: 0, name: t('close') },
      { id: 1, name: 'VIP' }
    ]

    return [
      { data: status, code: 'status', column: 'status' },
      { data: visibility, code: 'visibility', column: 'visibility' },
      { data: tags, code: 'categories', column: 'tag_id' }
    ]
  }

  return {
    novelties,
    loading,
    showForm,
    tags,
    openDeleteNovelty,
    noveltySelected,
    setNoveltySelected,
    setOpenDeleteNovelty,
    handleEditNovelties,
    handleDeleteNovelties,
    handleClickHighlight,
    handleClickSetOptions,
    handleCreateNovelty,
    createOptionsData,
    fetchNovelties
  }
}
